import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from '../../locales/i18n';

import './CategoriesField.css';

const CategoriesField = ({ name, categories, placeholder, multi, clearable = true }) => {
    const { t } = useTranslation();

    const list = Array.isArray(categories) ? categories : [];
    const tree = list.length > 0 ? Utils.sortAndIndentCats(list) : [];
    const idField = list[0] && ('id' in list[0]) ? 'id' : '_id';

    const options = tree.map(category => {
        return {
            key: category[idField],
            text: Utils.localized_or_fallback(category.name, i18n.language),
            value: category[idField],
            className: Utils.tree_depth_class(category.depth),
        };
    });

    return multi ? (
        <MultiSelectField
            name={ name }
            options={ options }
            placeholder={ placeholder || t('articlecategories.choose_a_category') }
            clearable={clearable}
        />
    ) : (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ placeholder || t('articlecategories.choose_a_category') }
            clearable={clearable}
        />
    );
}

export default CategoriesField;
